import { BLOCKS, INLINES } from '@contentful/rich-text-types';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import ContentfulImage from '@moxy/react-contentful-image';

import CallToAction from 'contentful/shared/call_to_action';
import FullScreenVideo from './full_screen_video';
import QuoteBox from './quote_box';

const richTextOptions = {
  renderNode: {
    [INLINES.HYPERLINK]: ({ data }, children) => (
      <a href={data.uri} className="fw-600 td-u">
        {children}
      </a>
    ),
    [BLOCKS.PARAGRAPH]: (node, children) => (
      <p className="fs-16 lh-1-5 mb-24">{children}</p>
    ),
    [BLOCKS.HEADING_1]: (node, children) => (
      <h1 className="tc-main fs-48 m-fs-60 mb-45 ff-body lh-1-2">{children}</h1>
    ),
    [BLOCKS.HEADING_2]: (node, children) => {
      // This adds the ID from the content for this heading if it exists.
      const {
        data: { id: tagID },
      } = node;
      return (
        <h2 className="fs-48 ff-body mb-32 lh-1-2" id={tagID}>
          {children}
        </h2>
      );
    },
    [BLOCKS.HEADING_3]: (node, children) => (
      <h3 className="fs-32 ff-body mb-24 lh-1-2">{children}</h3>
    ),
    [BLOCKS.HEADING_4]: (node, children) => (
      <h4 className="fs-24 ff-body mb-24 lh-1-2">{children}</h4>
    ),
    [BLOCKS.HEADING_5]: (node, children) => (
      <h5 className="fs-20 ff-body mb-16 lh-1-2">{children}</h5>
    ),
    [BLOCKS.HEADING_6]: (node, children) => (
      <h6 className="fs-20 fw-400 mb-16 lh-1-4">{children}</h6>
    ),
    [BLOCKS.UL_LIST]: (node, children) => (
      <ul className="evergreen__container__ul">{children}</ul>
    ),
    [BLOCKS.OL_LIST]: (node, children) => (
      <ol className="evergreen__container--ol">{children}</ol>
    ),
    [BLOCKS.LIST_ITEM]: (node, children) => (
      <li className="evergreen__container__li">{children}</li>
    ),

    [BLOCKS.EMBEDDED_ASSET]: ({ data }) => {
      const { title, description, file } = data.target.fields;
      const mimeType = file.contentType;
      const mimeGroup = mimeType.split('/')[0];

      switch (mimeGroup) {
        case 'image':
          return (
            <div className="evergreen__content__inline-image">
              <ContentfulImage
                alt={data.target.fields.title || data.target.fields.description}
                width={data.target.fields.file.details.image.width}
                height={data.target.fields.file.details.image.height}
                image={`https://${data.target.fields.file.url}`}
              />
            </div>
          );
        case 'application':
          return (
            <a alt={description || null} href={file.url}>
              {title || file.details.fileName}
            </a>
          );
        default:
          return (
            <span style={{ backgroundColor: 'red', color: 'white' }}>
              {' '}
              {mimeType} embedded asset{' '}
            </span>
          );
      }
    },
    [BLOCKS.EMBEDDED_ENTRY]: ({ data }) => {
      const fields = data.target.fields;
      const item = {
        link: fields.url,
        title: fields.videoTitle,
      };
      switch (data.target.sys.contentType.sys.id) {
        case 'videoPlayer':
          return (
            <div className="evergreen__content__inline-video">
              <FullScreenVideo key={data.target.sys.id} item={item} />
            </div>
          );
        case 'videoEmbed':
          return (
            <iframe
              src={data.target.fields.embedUrl}
              height="100%"
              width="100%"
              frameBorder="0"
              scrolling="no"
              title={data.target.fields.title}
              allowFullScreen
            />
          );
        case 'callToAction':
          return <CallToAction content={fields} />;
        case 'quotationBox':
          return (
            <div className="evergreen__container__inline-quote">
              <QuoteBox
                key={data.target.sys.id}
                id={data.target.sys.id}
                content={fields}
              />
            </div>
          );
        default:
          return <div>this is a test</div>;
      }
    },
  },
};

const RTECompose = ({ content }) => (
  <>{documentToReactComponents(content, richTextOptions)}</>
);

export default RTECompose;
